/* eslint-disable no-restricted-globals */
import {getGameId} from 'hiya-common/src/utils/helper'
import {formatBigNum} from 'hiya-common/src/utils'
// 获取游戏的引导状态 yes 即是已引导
export const getGameGuideStatus = (mid) => {
  const game_id = getGameId()
  return localStorage.getItem(`GreedyCat-${game_id}-${mid}`)
}
// 获取迎新用户礼包的引导状态 yes 即是已引导
export const getNewerGameGuideStatus = (mid) => {
  const game_id = getGameId()
  return localStorage.getItem(`GreedyCatNewer-${game_id}-${mid}`)
}
// 设置游戏引导已经done
export const setGameGuideStatus = (mid) => {
  const game_id = getGameId()
  localStorage.setItem(`GreedyCat-${game_id}-${mid}`, 'yes')
}
// 设置迎新用户礼包引导状态已经done
export const setNewerGameGuideStatus = (mid) => {
  const game_id = getGameId()
  localStorage.setItem(`GreedyCatNewer-${game_id}-${mid}`, 'yes')
}

// 获取客户端引导点击游戏
export const getGreedyCatGuide = (mid) => {
  return localStorage.getItem(`GreedyCat-Os-Guide${mid}`)
}

export const setGreedyCatGuide = (mid) => {
  return localStorage.setItem(`GreedyCat-Os-Guide${mid}`, new Date().toString())
}
// 获取游戏的默认下注额度
export const getGameBetChip = () => {
  const game_id = getGameId()
  return Number(localStorage.getItem(`GreedyMoldBet-${game_id}`) || 0)
}
export const setGameBetChip = (num) => {
  const game_id = getGameId()
  localStorage.setItem(`GreedyMoldBet-${game_id}`, num)
}
// 层级问题
export enum ZIndexEnum {
  winBtn = 20,
  guidePage = 900,
  guidePageModal = 11000, // 最外层引导层级
  staticPageModal = 10900, // 静态结果弹窗层级
  dynamicPageModal = 10800, // 静态结果弹窗层级
  rulePageModal = 10700, // 静态结果弹窗层级
}

export const mapChangeFinger = [1, 2, 3, 4, 5, 6, 7, 0]
// 对应高亮的真实index，用于换算目标到当前坐标需要跳转的渲染距离
export const mapBoxIndex = [0, 1, 2, 3, 4, 5, 6, 7]
// 划算并补足目前位置到目标位置的index距离，如果距离开奖结果的位置<3
// 就加一部分，例如目前位置到目标位置为0就去让结果渲染动画补一圈
export const getAfterDrawMapBox = ({
  nextIndex,
  targetIndex,
}: {
  nextIndex: number
  targetIndex: number
}) => {
  const distance = targetIndex - nextIndex
  if (distance === 0) {
    // 直接转一圈
    return (
      mapBoxIndex
        // 截取末尾
        .slice(nextIndex)
        // 拼接头部
        .concat(mapBoxIndex.slice(0, targetIndex + 1))
    )
  }
  if (distance > 0) {
    if (distance >= 3) {
      return mapBoxIndex.slice(nextIndex, targetIndex + 1)
    }
    return mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
  }
  if (distance < 0) {
    const normalArr = mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
    if (normalArr.length < 3) {
      return mapBoxIndex
        .slice(nextIndex)
        .concat(mapBoxIndex, mapBoxIndex.slice(0, targetIndex + 1))
    }
  }
  // distance < 0 的情况 也就是target在当前指示的后面 并且距离大于3
  return mapBoxIndex
    .slice(nextIndex)
    .concat(mapBoxIndex.slice(0, targetIndex + 1))
}
// 热门list
export const hot_list = [1, 2, 3]

export const getIndex = (list, id) => {
  const myId = list?.findIndex((ite) => ite?.target_id === id)
  if (myId !== -1) {
    return myId + 1
  }
  return 0
}

export const getBigNum = ({
  num,
  max,
  reserveNum,
}: {
  num: number
  max?: number
  reserveNum?: number
}) => {
  if (max && num < max) {
    return num
  }
  return formatBigNum(Number(num) || 0, reserveNum || 1)
}

// 数值替换规则--仅greedyCat使用 - 自己下注额
export function abbreviateBetAmount(bet: number): string {
  // 检查传入参数是否为有效数字且在有效范围内
  if (typeof bet !== 'number') {
    return '0'
  }

  if (bet < 100000) {
    // 下注额【1,10w）时 ， 下注额不缩写
    return bet.toString()
  }
  if (bet < 1000000) {
    // 下注额【10w, 100w)时，下注额用K来缩写，小数点保留到2位（如果只有1位的话就展示1位，不用刻意展示两位）
    const amountInK = (bet / 1000).toFixed(2)
    // 去除末尾多余的0
    const trimmedAmount = parseFloat(amountInK).toString()
    return `${trimmedAmount}K`
  }
  // 下注额≥100w时 ，下注额用M来缩写，保留整数位（向下取整）
  const amountInM = Math.floor(bet / 1000000)
  return `${amountInM}M`
}

export function abbreviateBet(bet: number): string {
  // 对传入的参数进行规范判断
  if (typeof bet !== 'number' || isNaN(bet) || bet < 1) {
    return '0'
  }

  if (bet < 100000) {
    // 下注额【1,10w）时 ， 下注额不缩写
    return bet.toString()
  }
  if (bet < 1000000) {
    // 下注额【10w, 100w)时， 下注额用K来缩写，保留整数位（向上取整即可）
    const amountInK = Math.ceil(bet / 1000)
    return `${amountInK}K`
  }
  // 下注额≥100w时 ， 下注额用M来缩写，保留整数位（向下取整）
  const amountInM = Math.floor(bet / 10000) / 100
  return `${amountInM}M`
}
